import axios from "axios";
import { getOrCreateDeviceId } from "../utils/deviceId";

const getHostName = () => process.env.REACT_APP_HOST_NAME_BACKEND;

const refreshClient = axios.create({
  baseURL: `${getHostName()}/api/v1/`,
  timeout: 30000,
  withCredentials: true
});

const RefreshTokenService = {

  async performTokenRefresh() {
    const deviceId = getOrCreateDeviceId();
    const payload = { deviceId };
    await refreshClient.post("/auth/refresh", payload);
    return true;
  }
};

export default RefreshTokenService;
